import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ResizableHandle from '../../QueryTool/ResizablePanels'
import PipelineEditorProvider from './PipelineEditorContext'
import PipelineHeader from './PipelineHeader'
import ChatPanel from './ChatPanel'
import EditorPanel from './EditorPanel'

const useStyles = makeStyles(theme => ({
  editPipelineLayout: {
    height: `calc(100vh - ${theme.layout.appBar.height}px)`,
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--surface-bg-color-d4)'
  },
  header: {
    flexShrink: 0,
    borderBottom: '1px solid var(--color-neutral-600)',
    backgroundColor: 'var(--surface-bg-color-d3)'
  },
  panelsContainer: {
    flex: 1,
    display: 'flex',
    overflow: 'hidden',
    position: 'relative'
  },
  chatPanel: {
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRight: '1px solid var(--color-neutral-600)',
    backgroundColor: 'var(--surface-bg-color-d3)'
  },
  editorPanel: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: 'var(--surface-bg-color-d4)'
  }
}))

function EditPipelineHome ({ pipeline }) {
  const classes = useStyles()
  const [chatWidth, setChatWidth] = useState(() => {
    const saved = localStorage.getItem('pipelineEditor.chatWidth')
    return saved ? parseInt(saved, 10) : 600
  })

  const handleResize = useCallback((delta) => {
    setChatWidth(prev => {
      const newWidth = Math.max(400, Math.min(800, prev + delta))
      localStorage.setItem('pipelineEditor.chatWidth', newWidth.toString())
      return newWidth
    })
  }, [])

  const handleDoubleClick = useCallback(() => {
    setChatWidth(600)
    localStorage.setItem('pipelineEditor.chatWidth', '600')
  }, [])

  return (
    <PipelineEditorProvider initialValue={pipeline}>
      <div className={classes.editPipelineLayout}>
        <div className={classes.header}>
          <PipelineHeader />
        </div>
        <div className={classes.panelsContainer}>
          <div className={classes.chatPanel} style={{ width: `${chatWidth}px` }}>
            <ChatPanel />
          </div>
          <ResizableHandle
            direction='horizontal'
            onResize={handleResize}
            onDoubleClick={handleDoubleClick}
          />
          <div className={classes.editorPanel}>
            <EditorPanel />
          </div>
        </div>
      </div>
    </PipelineEditorProvider>
  )
}

EditPipelineHome.propTypes = {
  pipeline: PropTypes.object
}

export default EditPipelineHome
